import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useElapsedTime } from '@/util/timerHooks';

const Timer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10em;
  font-family: monospace;
  font-weight: 500;
`;

const leftPad = val => (String(val).length < 2 ? `0${val}` : val);

const formatDuration = seconds => {
  const hrs = Math.floor(seconds / 3600);
  const mnt = Math.floor((seconds - hrs * 3600) / 60);
  const sec = seconds % 60;
  return [leftPad(hrs), leftPad(mnt), leftPad(sec)].join(':');
};

const CleaningClock = props => {
  const cleaningStartedAtDefault = useMemo(() => new Date(), []);

  return (
    <Timer>
      <Duration since={props?.room?.cleaningStartedAt || cleaningStartedAtDefault} />
    </Timer>
  );
};

export default CleaningClock;

const Duration = ({ since }) => {
  // Use the proper useElapsedTime hook for elapsed time calculations
  const { elapsedSeconds } = useElapsedTime({
    startTime: since,
    interval: 1000,
    precision: 'second',
  });
  return <>{formatDuration(elapsedSeconds)}</>;
};
